// Single owner of the Live updates route + Olo webhook setup deep-link
// contract, shared across scene boundaries (LiveUpdates can't import
// RecoveryAI's routes.ts or vice versa — see CLAUDE.md's scene-boundary
// rule). Previously this literal and the two param/value literals it
// composes with were copy-pasted into LiveUpdates/index.constants.ts,
// RecoveryAI/routes.ts, scenes/Routes.tsx's route registration, and the
// Navbar's Experiences link, guarded only by a comment ("keep in sync") and a
// test asserting two hardcoded strings equal each other — a rename of any one
// copy left every other copy, and that test, silently wrong. Importing this
// module everywhere makes drift a compile error instead.
export const LIVE_UPDATES_PATH = '/live_updates'

// RecoveryAI's Olo webhook banner CTA (AI-1295 / FR-39) sends the merchant to
// Live updates with this param so the "Connect Olo webhooks" modal opens on
// arrival instead of landing them on a page with the same banner and the same
// button to click again.
export const OLO_WEBHOOK_SETUP_PARAM = 'olo_webhook'
export const OLO_WEBHOOK_SETUP_VALUE = 'setup'
